import React, { Suspense } from 'react';
import { IPlayerStatistics } from '@sky-it-livedata/livedata-live-match-pages-widgets';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const PlayerStatisticsWrapper = React.lazy(() => import('./player-statistics'));
export interface IDynamicPlayerStatisticsDetailWrapper extends IComponentModel<IPlayerStatistics> {
  live?: boolean;
  model: any;
}

const DynamicPlayerStatisticsDetail = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live = false,
}: IDynamicPlayerStatisticsDetailWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <PlayerStatisticsWrapper
      initialModel={validateModel(model) as IPlayerStatistics}
      query={validateModel(query)}
      live={live}
    />
  </Suspense>
);

DynamicPlayerStatisticsDetail.defaultProps = {
  live: false,
};

export default DynamicPlayerStatisticsDetail;
